import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useSelector } from "react-redux";
import { selectSiteData } from "../../../../store/selectors/commonSelectors";

const GoogleMapSection = () => {
  const containerStyle = {
    width: "100%",
    height: "500px",
  };
  const siteData = useSelector(selectSiteData);
  const lat = parseFloat(siteData?.locations?.[0]?.latitude);
  const lng = parseFloat(siteData?.locations?.[0]?.longitude);

  // Center the map (between two offices)
  const center = { lat, lng };

  // Office locations
  const officeLocations = [
    {
      lat,
      lng,
      name: siteData?.locations?.[0]?.address,
    },
  ];

  // Function to open Google Maps with directions
  const openGoogleMaps = (lat, lng) => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

    window.open(url, "_blank");
  };
  return (
    <LoadScript googleMapsApiKey="AIzaSyDOpIJdNOOB2r5u-3BtVW5vNTgEjH-53vI">
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={15}>
        {officeLocations.map((office, index) => (
          <Marker
            key={index}
            position={{ lat: office.lat, lng: office.lng }}
            title={office.name}
            onClick={() => openGoogleMaps(office.lat, office.lng)} // Click to open Google Maps
          />
        ))}
      </GoogleMap>
    </LoadScript>
  );
};
export default GoogleMapSection;
